import type { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import { IntentKind } from '@jet-app/music-classical/intents';
import { NetworkError } from '@jet-app/music-classical/utilities';
import {
    playActionForClassicalPlayAction,
    type PlayAction,
} from '@jet-app/music-classical/action-model/PlayAction';
import type { QueryPlaybackIntent } from './QueryPlaybackIntent';
import { requestQueryPlaybackData } from '@jet-app/music-classical/api/request-query-playback-data';
import type { ClassicalAPIResponseAction } from '@jet-app/music-classical/api/types';

export const QueryPlaybackIntentController: IntentController<QueryPlaybackIntent> =
    {
        $intentKind: IntentKind.QUERY_PLAYBACK_INTENT,

        async perform(
            intent: QueryPlaybackIntent,
            objectGraph: ObjectGraph,
        ): Promise<PlayAction> {
            const { query } = intent;
            const apiResponse = await requestQueryPlaybackData(
                query,
                objectGraph,
            );

            if (!apiResponse?.body) {
                throw NetworkError.noContent();
            }

            const action =
                apiResponse?.body as unknown as ClassicalAPIResponseAction;

            return playActionForClassicalPlayAction(action);
        },
    };
